var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "64px",
    viewBox: "0 0 300 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.001 47.9583V28.6062C157.941 23.2002 161.716 18.3628 167.38 16.5872C169.58 15.8622 174.507 15.6613 176.852 15.9932V23.5751C176.411 23.5751 173.32 23.5095 172.879 23.5751C168.848 23.8371 166.503 26.0209 166.503 29.4536V47.9496L158.001 47.9583Z",
    fill: "#011B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.081 17.1371C237.11 12.6387 224.145 20.3472 224 32.1654C223.995 34.3588 224.428 36.535 225.279 38.5899C228 44.7708 234.623 48.8343 242 48.8489C249.377 48.8632 256.019 44.8256 258.769 38.6555C262.646 30.1128 258.131 20.5394 249.081 17.1371ZM242.063 41.6891C239.315 41.6891 236.711 40.5752 234.973 38.6555L234.992 38.6511C231.32 34.8101 231.633 29.0475 235.705 25.5488C240.481 21.3735 248.175 22.7886 250.883 28.6976C252.457 32.043 251.786 35.9037 249.153 38.6555C247.416 40.5752 244.812 41.6891 242.063 41.6891Z",
    fill: "#011B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265 47.4593V29.3696C265 23.0105 269.029 17.8876 275.143 15.9397C287.526 12.044 298.326 19.0537 298.326 29.3696V47.5466H289.972V29.5004C289.972 25.0894 286.665 22.0366 281.766 22.0366C276.868 22.0366 273.346 25.0239 273.346 29.5004V47.4593H265Z",
    fill: "#011B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.532 31.5238C219.532 31.4322 219.532 31.3405 219.532 31.2489C219.4 29.3537 218.978 27.4839 218.277 25.6934C215.942 19.7669 209.808 15.8581 202.241 15.8581H194.79V23.9509H202.105C207.12 23.9509 210.632 26.9033 210.976 31.2489H210.947C210.947 31.4235 210.947 31.5981 210.971 31.7729C210.982 34.2218 209.901 36.5722 207.972 38.2966C206.043 40.021 203.427 40.9748 200.71 40.9444C195.066 40.8788 190.536 36.7168 190.536 30.8995V0H182V31.1135C182 41.6172 189.621 48.4913 200.763 48.4257C211.306 48.4257 218.97 41.6389 219.507 32.9347H219.546C219.561 32.4718 219.556 32 219.532 31.5238Z",
    fill: "#011B33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 32.7401C115 32.832 115 32.9237 115 33.0153C115.135 34.9092 115.559 36.777 116.26 38.5664C118.58 44.4972 124.694 48.406 132.281 48.406H139.752V40.3134H132.441C127.427 40.3134 123.914 37.3609 123.57 33.0153H123.599C123.599 32.8407 123.599 32.6659 123.599 32.4913C123.589 30.0421 124.669 27.6918 126.598 25.9676C128.528 24.2432 131.144 23.2893 133.86 23.3197C139.505 23.3852 144.034 27.5474 144.034 33.3648V48.297H152.537V33.1507C152.537 22.6472 144.916 15.7728 133.773 15.8384C123.236 15.8384 115.562 22.6166 115 31.3252C115 31.3252 115 32.2642 115 32.7401Z",
    fill: "#011B33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.622 39.7408H99.2567C93.9855 39.7408 90.391 36.4345 90.4683 31.6829C90.4683 26.9966 94.0582 23.8215 99.2567 23.8215H110.622V15.8379H99.1016C86.951 15.8379 78.7008 26.1713 83.2838 38.02C85.5752 43.8767 91.6166 47.7331 99.1016 47.7331H110.622V39.7408Z",
    fill: "#011B33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M61.4928 15.8379H41L61.4928 47.8424V15.8422V15.8379Z",
    fill: "#011B33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7443 15.9978L31 0L41.2515 15.9978H61.7443Z",
    fill: "#011B33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.9909 16.0022L30.7443 0L0 16.0022H40.9909Z",
    fill: "#011B33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 47.8424H20.4978L0 15.8379V47.8424Z",
    fill: "#011B33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.5135L30.7443 63.5112L20.4978 47.5135H0Z",
    fill: "#011B33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20 47.5135L30.2513 63.5112L60.9907 47.5135H20Z",
    fill: "#011B33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonDark);
export default __webpack_public_path__ + "static/media/carbon-dark.916f6055e863c02641eec576a479d583.svg";
export { ForwardRef as ReactComponent };